/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { usePathname } from "@i18n/next";
import { useRequestMe } from "@packages/sdk";
import { Loader, numericPercentages, numericPixels } from "@packages/ui";
import { useMemo } from "react";

import { SettingsSidebar } from "./SettingsSidebar";

const SETTINGS_PATHNAMES_WITHOUT_SIDEBAR = [
  "/settings/change-pin",
  "/settings/kids-profiles/add",
];

const contentStyles: Interpolation = {
  flex: "1",
  paddingBottom: numericPixels[48],
};

const loadingStyles: Interpolation = {
  alignItems: "center",
  display: "flex",
  justifyContent: "center",
  width: numericPercentages[100],
};

export const SettingsContent = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { query: user } = useRequestMe();
  const pathname = usePathname();
  const shouldShowSidebar = !SETTINGS_PATHNAMES_WITHOUT_SIDEBAR.some(
    (pathnameWithoutSidebar) => pathname.includes(pathnameWithoutSidebar),
  );

  const pageIsAllowed = useMemo(() => {
    return (
      pathname.includes("/app") ||
      pathname.includes("/language") ||
      pathname.includes("/legal") ||
      pathname.includes("/gift") ||
      /^\/settings\/?$/.test(pathname)
    );
  }, [pathname]);

  if (!user.data && !pageIsAllowed) {
    return (
      <div css={loadingStyles}>
        <Loader />
      </div>
    );
  }

  return (
    <>
      {shouldShowSidebar && <SettingsSidebar />}
      <section css={contentStyles}>{children}</section>
    </>
  );
};
